import * as TYPES from './mutationTypes'

export default {
  updateChainCid(state, param) {
    state.chainCid = param
  },
  updateLoading(state, params) {
    state.homeLoading = params
  },
  //全部订阅列表
  [TYPES.GET_ALL_SUBSCRIBE](state, payload) {
    const { limit, offset, total } = payload.result
    let newArr = payload.result.items.map(ele => {
      let item = {
        ...ele.Chain,
        ...ele.Overview
      }
      return item
    })
    Object.assign(state, {
      subscribe_list: newArr,
      subscribe_paging: { limit, offset, total }
    })
  },
  //区块
  [TYPES.GET_BLOCK_LIST](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      block_list: payload.result.items,
      block_paging: { limit, offset, total }
    })
  },
  //合约
  [TYPES.GET_CONTRACT_LIST](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      contract_list: payload.result.items,
      contract_paging: { limit, offset, total }
    })
  },
  //交易
  [TYPES.GET_TXN_LIST](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      txn_list: payload.result.items,
      txn_paging: { limit, offset, total }
    })
  }
}
